<template>
  <div class="first-column-cell-icon-container">
    <button
      v-if="canExpand"
      class="expansion-icons-container"
      @click="expandRow"
    >
      <img
        :alt="isExpanded ? $t('sbTable.collapseRow') : $t('sbTable.expandRow')"
        :src="ChevronRightIcon"
        class="expand-icon-chevron"
        :aria-expanded="isExpanded"
        :aria-label="isExpanded ? $t('sbTable.collapseRow') : $t('sbTable.expandRow')"
        :class="isExpanded ? 'expanded' : ''"
      >
    </button>
    <SbCheckbox
      v-if="canMultiSelect"
      v-model:checked="selectedRows"
      :disabled="disabled"
      :value="row"
      class="sb-table__select checkbox-selectable"
      :class="[
        canExpand ? 'can-expand' : '',
        tableCanExpand && !(row.getCanExpand() || subrowCanExpand) ? 'checkbox-row-not-expandable' : ''
      ]"
      :indeterminate="isIndeterminate"
    />
  </div>
</template>

<script>
import SbCheckbox from '@src/components/Checkbox/SbCheckbox.vue';
import ChevronRightIcon from '@public/media/icons/chevron-right.svg';

export default {
  name: 'SbTableExpandCollapseRowCell',
  components: {
    SbCheckbox,
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    tableCanExpand: {
      type: Boolean,
      default: true,
    },
    subrowCanExpand: {
      type: Boolean,
      default: false,
    },
    enableRowSelection: {
      type: Boolean,
      default: false,
    },
    /** Used to determine if there is a selectable sub table row */
    subRowsTableSelectable: {
      type: Boolean,
      default: false,
    },
    /** Used to determine if the checkbox will show as disabled */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
    * Emitted when a change in row selection happens
    */
    'row-selection-updated',
    /**
     * Emitted when a change in row selection occurs. This is for a sub selectable table
    */
    'row-selection-updated-selectable-sub-table',
  ],
  data: () => ({
    ChevronRightIcon,
    isChecked: false,
  }),
  computed: {
    canMultiSelect() {
      if (typeof this.enableRowSelection === 'function') return true;
      return this.enableRowSelection;
    },
    canExpand() {
      return this.tableCanExpand && (this.row.getCanExpand() || this.subrowCanExpand);
    },
    isExpanded() {
      return this.row.getIsExpanded();
    },
    isIndeterminate() {
      if (!this.subRowsTableSelectable) return false;
      if (this.row.getIsSelected()) return false;
      const subrows = this.row.subRows || [];
      return subrows.some((r) => r.getIsSelected());
    },
    selectedRows: {
      get() {
        return this.row.getIsSelected() || this.isIndeterminate;
      },
      set() {
        this.row.toggleSelected();
        if (this.row.getIsSelected()) {
          this.expandAllChildren();
        }
        this.$emit('row-selection-updated');
        if (this.subRowsTableSelectable) {
          this.$emit('row-selection-updated-selectable-sub-table', { rows: this.row, isAllCell: false });
        }
      },
    },
  },
  methods: {
    expandRow() {
      this.row.toggleExpanded();
    },
    expandAllChildren() {
      const expand = (r) => {
        if (r.getCanExpand() && !r.getIsExpanded()) {
          r.getToggleExpandedHandler()();
          r.subRows?.forEach(expand);
        }
      };
      expand(this.row);
    },
  },
};
</script>

<style lang="scss">
.checkbox-selectable {
  margin-right: 0.75em;

  &.can-expand {
    margin-left: 1em;
  }
}
</style>
